module.exports = __webpack_public_path__ + "static/img/RWA666-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWA666-G_1.png
// module id = nJmw
// module chunks = 0